import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import * as moment from "moment";
import {MatDialog} from "@angular/material/dialog";
import {CheckExpertiseModalComponent} from "../check-expertise-modal/check-expertise-modal.component";
import {
  FormPdfSignatureComponent,
  IFormPdfSignatureComponentDataExpertiseInfo
} from "../form-pdf-signature/form-pdf-signature.component";
import {
  CExpertiseResponseStringByCodeNumber,
  ExpertiseService,
  IDictionary,
  IDownloadExpertiseFile,
  IExpertiseDoc,
  ISampleSignInfo,
  IUploadExpertiseBody,
  IUploadSignedConsentPdfFileResult
} from "../../../../shared/services/expertise.service";
import {finalize} from "rxjs/internal/operators/finalize";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-new-expertise',
  templateUrl: './new-expertise.component.html',
  styleUrls: ['./new-expertise.component.scss']
})
export class NewExpertiseComponent implements OnInit, OnChanges {

  @Input() index: number;
  @Input() objectName: string;
  @Input() objectId: number;
  @Input() regionID: number;
  @Input() sampleSignInfo: ISampleSignInfo;

  @Input() expertiseTypes: IDictionary[];
  @Input() expertise: IExpertiseDoc;
  calendarModal = false;
  form = new FormGroup({
    id: new FormControl(),
    number: new FormControl(null, Validators.required),
    date: new FormControl(null, Validators.required),
    expertiseType: new FormControl(null, Validators.required),
    isIntegration: new FormControl()
  });
  @Output() isRemove: EventEmitter<boolean> = new EventEmitter();
  @Output() isSignSampleUploaded: EventEmitter<boolean> = new EventEmitter();
  @Output() isCreated: EventEmitter<boolean> = new EventEmitter();
  @Output() isActiveChange: EventEmitter<boolean> = new EventEmitter();

  numberCount = 7;


  @ViewChild('conclusionFile') conclusionFile: ElementRef;
  notificationText = '"Файл экспертного заключения, файлы kenml и файлы ПСД прикрепляются вручную."'

  get id() {
    return this.form.get('id');
  }

  get expertiseType() {
    return this.form.get('expertiseType');
  }

  get documentDate() {
    return this.form.get('date');
  }

  get documentNumber() {
    return this.form.get('number');
  }

  get isIntegration() {
    return this.form.get('isIntegration');
  }

  get privateBtnEnable() {
    return this.documentNumber?.value && this.documentDate?.value && this.file;
  }

  constructor(private dialog: MatDialog,
              private expService: ExpertiseService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
    this.form.patchValue(this.expertise);
    if (this.sampleSignInfo && this.sampleSignInfo?.notAfter) {
      this.checkSampleSignInfo();
    }
    this.documentDate.valueChanges.subscribe(_ => {
      this.expertise.authorConsentFileInfo = null;
    });
    this.documentNumber.valueChanges.subscribe(_ => {
      this.expertise.authorConsentFileInfo = null;
    });
    this.expertiseType.valueChanges.subscribe(res => {
      this.expertise.expertiseType = res;
      this.expertise.expertiseTypeTitle = this.expertiseTypes.find(f => f.id === res).title || '';
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes['sampleSignInfo']?.firstChange) {
      this.checkSampleSignInfo();
    }
  }

  openCalendar() {
    this.calendarModal = true;
  }

  closeCalendar(date: number) {
    this.documentDate.setValue(moment(date).format('YYYY-MM-DD'));
    this.form.markAsDirty();
    this.calendarModal = false;
  }

  protected readonly document = document;

  remove() {
    this.isRemove.emit(true);
  }

  checkLoader = false;

  checkExpertise() {
    this.checkLoader = true;
    this.expService.checkExpertise(this.documentDate?.value, this.documentNumber?.value, this.expertise.authorConsentFileInfo.fileID,
      this.expertise.id ? this.expertise.id : this.expertiseIDfromConsentPdfFile)
      .pipe(
        finalize(() => this.checkLoader = false)
      )
      .subscribe(result => {
        this.dialog.open(CheckExpertiseModalComponent, {
          width: '500px',
          height: '480px',
          hasBackdrop: false,
          data: {
            errorStatus: result.errorStatus,
            objectName: this.objectName,
            incomeObjectName: result.objectTitle,
            errorText: CExpertiseResponseStringByCodeNumber[result.responseType],
            expertiseInfo: {
              docNumber: this.documentNumber?.value,
              docDate: this.documentDate?.value,
              fileID: this.expertise?.authorConsentFileInfo?.fileID,
              expertiseID: this.expertise.id ? this.expertise.id : this.expertiseIDfromConsentPdfFile
            }
          }
        }).afterClosed().subscribe((res: { type: string, result: any }) => {
          console.log(res, 'result after closed');
          if (res.type === 'accept') {
            this.expertise.conclusionFileInfo = {
              fileID: res.result.conclusionFileID,
              fileName: res.result.fileName,
              fileDate: '',
              groupID: 3
            }
            this.isCreated.emit(true);
          } else if (res.type === 'attach') {
            this.isIntegration.setValue(false);
            if (this.expertiseIDfromConsentPdfFile) {
              this.expertise.id = this.expertiseIDfromConsentPdfFile;
            }
            setTimeout(() => {
              this.attachFile();
            }, 500);
          }
        });
      });
  }

  getSamplePdf() {
    const obj: IFormPdfSignatureComponentDataExpertiseInfo = {
      documentDate: this.documentDate?.value,
      documentNumber: this.documentNumber?.value,
      objectName: this.objectName,
      expertiseID: this.expertise.id,
      expertiseType: this.expertise.expertiseType,
      livingComplexID: this.objectId,
      regionID: this.regionID
    }
    const dialogRef = this.dialog.open(FormPdfSignatureComponent, {
      width: '500px',
      height: '385px',
      hasBackdrop: true,
      disableClose: true,
      data: {
        signType: 'mio_sample_ecp',
        info: obj
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isSignSampleUploaded.emit(true);
      }
    });
  }

  checkSampleSignInfo() {
    const noAfter = moment(this.sampleSignInfo.notAfter, 'DD.MM.YYYY').format('YYYY-MM-DD');
    if (noAfter > moment().format('YYYY-MM-DD')) {
      this.sampleSignInfo.text = `ЭЦП актуальна до ${noAfter}`;
      this.sampleSignInfo.bool = true;
    } else {
      this.sampleSignInfo.text = `ЭЦП устарел`;
      this.sampleSignInfo.bool = false;
    }
  }


  expertiseIDfromConsentPdfFile: number;

  getConsentFormPdf() {

    /* Загружаем информацию по образцу ЭЦП */
    const obj: IFormPdfSignatureComponentDataExpertiseInfo = {
      documentDate: this.documentDate?.value,
      documentNumber: this.documentNumber?.value,
      objectName: this.objectName,
      expertiseID: this.expertise.id,
      expertiseType: this.expertise.expertiseType,
      livingComplexID: this.objectId,
      regionID: this.regionID
    }
    const dialogRef = this.dialog.open(FormPdfSignatureComponent, {
      width: '500px',
      height: '385px',
      hasBackdrop: true,
      disableClose: true,
      data: {
        signType: 'mio_sample_ecp',
        info: obj
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.isSignSampleUploaded.emit(true);

        /* Формируем шаблон и подписываем по ЭЦП */

        const obj: IFormPdfSignatureComponentDataExpertiseInfo = {
          documentDate: this.documentDate?.value,
          documentNumber: this.documentNumber?.value,
          objectName: this.objectName,
          expertiseID: this.expertise.id,
          expertiseType: this.expertise.expertiseType,
          livingComplexID: this.objectId,
          regionID: this.regionID
        }
        const dialogRef = this.dialog.open(FormPdfSignatureComponent, {
          width: '500px',
          height: '385px',
          hasBackdrop: true,
          disableClose: true,
          data: {
            signType: 'mio_consent_file',
            info: obj
          },
        });
        dialogRef.afterClosed().subscribe((result: IUploadSignedConsentPdfFileResult) => {
          if (result) {
            this.expertiseIDfromConsentPdfFile = result.expertiseID;
            this.expertise.id = result.expertiseID;
            this.id.setValue(result.expertiseID);
            this.expertise.authorConsentFileInfo = {
              fileID: result.authorConsentFileID,
              groupID: 1,
              fileDate: '',
              fileName: this.expService.createFileName(this.documentNumber?.value)
            }
          }
        });
      }
    });

  }

  downloadFile(fileID?: number, fileName?: string) {
    console.log(fileID, fileName, 'downloadFile');
    if (!fileID) return;
    const body: IDownloadExpertiseFile = {
      fileID,
      expertiseID: this.expertise.id,
      isKenml: false,
      remotePSD: false
    };
    console.log(body, 'body')
    this.expService.downloadExpertiseFile(body, fileName);
  }

  attachFile() {
    let elem: HTMLElement = this.conclusionFile.nativeElement;
    elem.click();
  }

  file: File;

  onFileChange(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    const file = files[0];
    this.file = file;
    this.form.markAsDirty();
    if (this.expertiseType?.value === 1) {
      this.expService.uploadExpertiseConclusionFile(this.expertise.id, file, file.name).subscribe(res => {
        if (res.errorStatus === 0) {
          this.toastr.success('Файл заключения экспертизы успешно загружен!');
          this.expertise.conclusionFileInfo = {
            fileID: res.conclusionFileID,
            fileName: file.name,
            fileDate: '',
            groupID: 3
          }
        }
        this.isCreated.emit(true);
      });
    } else if (this.expertiseType?.value === 3) {
      this.expertise.conclusionFileInfo = {
        fileID: null,
        fileName: file.name,
        fileDate: '',
        groupID: 3
      }
    }
  }

  savePrivateType() {
    const object: IUploadExpertiseBody = {
      expertiseID: this.expertise.id,
      livingComplexID: this.objectId,
      documentDate: moment(this.documentDate?.value).format('YYYY-MM-DDT00:00:00'),
      documentNumber: this.documentNumber?.value,
      expertiseType: this.expertiseType?.value,
      isIntegration: false,
      isActive: false,
      file: this.file,
      fileExtension: 'pdf',
      regionID: this.regionID
    }
    this.checkLoader = true;
    this.expService.uploadExpertise(object).subscribe(res => {
      this.checkLoader = false;
      if (res.errorStatus === 0) {
        this.expertise.id = res.expertiseID;
        this.id.setValue(res.expertiseID);
        this.expertise.isEdit = false;
        this.expertise.conclusionFileInfo.fileID = res.conclusionFileID;
        this.toastr.success('Частная эксперитиза успешно создана');
        this.isCreated.emit(true);
      } else {
        this.toastr.warning('Ошибка!');
      }
    }, _ => {
      this.checkLoader = false;
    });
  }

  transformDate(date: string) {
    return new Date(date).getTime();
  }

  getActiveChanges(event: boolean, expertise: IExpertiseDoc) {
    expertise.isActive = event;
    this.isActiveChange.emit(event)
  }


}
